"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxBigNumber = exports.minBigNumber = void 0;
const ethers_1 = require("ethers");
/** Returns the minimum of two big numbers */
const minBigNumber = (a, b) => ethers_1.BigNumber.from(a).lt(b) ? ethers_1.BigNumber.from(a) : ethers_1.BigNumber.from(b);
exports.minBigNumber = minBigNumber;
/** Returns the maximum of two big numbers */
const maxBigNumber = (a, b) => ethers_1.BigNumber.from(a).gt(b) ? ethers_1.BigNumber.from(a) : ethers_1.BigNumber.from(b);
exports.maxBigNumber = maxBigNumber;
